import { InitialValues } from 'forms/types';

import { Severity, SleepApneaFormValues } from '../form/types';
import { SleepApneaProfileQuery } from '../graphql/SleepApneaProfile';

const buildInitialValues = (data?: SleepApneaProfileQuery): InitialValues<SleepApneaFormValues> => {
  const sleepApneaProfile = data?.sleepApnea;

  return {
    diagnosedAt: sleepApneaProfile?.diagnosedAt,
    severity: sleepApneaProfile?.severity as Severity,
    everTreated: sleepApneaProfile?.everTreated,
    treatedAt: sleepApneaProfile?.treatedAt,
    usesCPAPMachine: sleepApneaProfile?.usesCPAPMachine,
    sleepStudyConducted: sleepApneaProfile?.sleepStudyConducted,
    sleepStudyConductedAt: sleepApneaProfile?.sleepStudyConductedAt,
    oxygenSaturation: sleepApneaProfile?.oxygenSaturation,
    apneaIndex: sleepApneaProfile?.apneaIndex,
    apneaHypopneaIndex: sleepApneaProfile?.apneaHypopneaIndex,
    respiratoryDisturbanceIndex: sleepApneaProfile?.respiratoryDisturbanceIndex,
  };
};

export default buildInitialValues;
